import _Vue from 'vue';
import axios from 'axios';
export default {
  install(Vue: typeof _Vue) {
    Vue.prototype.$addPv = (activityId: number) => {
      if (process.env.NODE_ENV === 'production') {
        axios.get(
          `https://goapi.cqcb.com/v1/news/count?classId=9&newsId=${activityId}`,
        );
      } else {
        console.log('添加pv成功');
      }
    };
  },
};
